import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "store";
import LandingTemplate from "components/templates/LandingTemplate";
import { eventLog } from "utils/AmplitudeUtil";
import { log, LogLevel } from "utils/LogUtil";
import { useChannelIOApi } from "react-channel-plugin";

const LandingPage: React.FC = () => {
  const navigate = useNavigate();
  const { isAuthenticated, isLoading } = useSelector((state: RootState) => state.user);
  const { openWorkflow } = useChannelIOApi();

  log(LogLevel.INFO, "[LandingPage] 렌더링", { isAuthenticated, isLoading });

  // Analytics: 랜딩 페이지 방문 추적
  useEffect(() => {
    if (!isLoading && !isAuthenticated) {
      eventLog("랜딩페이지_방문", {});
    }
  }, [isLoading, isAuthenticated]);

  // 로그인된 사용자는 자동으로 대시보드로 리다이렉트
  useEffect(() => {
    if (!isLoading && isAuthenticated) {
      eventLog("랜딩페이지_자동리다이렉트", { isAuthenticated: true });
      navigate("/dashboard", { replace: true });
    }
  }, [isAuthenticated, isLoading, navigate]);

  const handleLogin = () => {
    eventLog("랜딩페이지_로그인버튼_클릭", {});
    navigate("/login");
  };

  const handleChat = () => {
    eventLog("랜딩페이지_채팅버튼_클릭", {});
    openWorkflow("761739");
  };

  // 인증 상태 확인 중
  if (isLoading) {
    return null;
  }

  // 로그인된 사용자 (리다이렉트 전 깜빡임 방지)
  if (isAuthenticated) {
    return null;
  }

  return (
    <LandingTemplate
      onLogin={handleLogin}
      onChat={handleChat}
      externalUrl="https://phai.framer.website/"
    />
  );
};

export default LandingPage;
